module.exports = __webpack_public_path__ + "img/P150T_weapon_90.eda33964.png";